module.exports = __webpack_public_path__ + "static/media/DK4055_02.f444cd8e.jpg";